import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  createDeposit(tableId, { amount, paymentMethod }) {
    return axiosIns.post(
      `/waiter/tables/${tableId}/deposits`,
      snakecaseKeys({ deposit: { amount, paymentMethod } }),
    )
  },
  cancelDeposit(tableId, depositId) {
    return axiosIns.delete(`/waiter/tables/${tableId}/deposits/${depositId}`)
  },
}
